import type { BuyerSavedListing } from "./likedHomes";
import type { MainMatchingProperties } from "./cartProperties";
import type { BuyerMatchingPreferences } from "./buyerMatchingPreferences";

export interface CurrencyAmount {
  amount: number;
  currency: string;
}

export interface SavingsDetails {
  savings: CurrencyAmount;
  income: CurrencyAmount;
  creditScore: number;
  creditScoreLastUpdatedAt: Date;
  savingsNeeded: CurrencyAmount;
  affordability: CurrencyAmount;
  targetAffordability: CurrencyAmount;
}

interface FinanceItem {
  amount: CurrencyAmount;
  type: string;
}
interface Address {
  address1: string;
  address2: string;
  city: string;
  state: string;
  postalCode: string;
  country: string;
}

export enum BuyerHomeGoalPropertyTypeEnum {
  Detached = "DETACHED",
  SemiDetached = "SEMI_DETACHED",
  Townhouse = "TOWNHOUSE",
  CondoTownhouse = "CONDO_TOWNHOUSE",
  Condo = "CONDO",
  Apartment = "APARTMENT",
}

export const propertyTypeLabels: Record<BuyerHomeGoalPropertyTypeEnum, string> =
  {
    [BuyerHomeGoalPropertyTypeEnum.Detached]: "Detached",
    [BuyerHomeGoalPropertyTypeEnum.SemiDetached]: "Semi-Detached",
    [BuyerHomeGoalPropertyTypeEnum.Townhouse]: "Townhouse",
    [BuyerHomeGoalPropertyTypeEnum.CondoTownhouse]: "Condo Townhouse",
    [BuyerHomeGoalPropertyTypeEnum.Condo]: "Condo",
    [BuyerHomeGoalPropertyTypeEnum.Apartment]: "Apartment",
  };
export class BuyerHomeGoal {
  targetAmount?: CurrencyAmount;
  selectedCities?: string[];
  propertyTypes?: BuyerHomeGoalPropertyTypeEnum[];
}
export interface MainProfile {
  firstName?: string;
  lastName?: string;
  phoneNumber?: string;
  emailAddress: string;
  profession?: string;
  address?: Address;
  homeGoal?: BuyerHomeGoal;
  profileImageUrl?: ArrayBuffer | string | null;
  cognito: {
    userId: string;
    poolId: string;
  };
  finances: {
    income?: FinanceItem[];
    savings?: FinanceItem[];
    monthlyDebt?: FinanceItem[];
    preApprovals?: FinanceItem[];
    affordability?: CurrencyAmount;
    downPaymentAssistance?: CurrencyAmount;
  };
  matchedListings?: MainMatchingProperties[];
  type: string;
  matchingPreferences?: BuyerMatchingPreferences | null;
  notifications?: [];
  flinksConnect: [];
  cart: [];
  createdAt: string;
  updatedAt: string;
  likedHomes: BuyerSavedListing[];
  id: string;
  lastListingRefresh?: Date;
}
